import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { CountryCode } from '../urls-config';
import { useTrimContext } from './hooks/useTrimContext';
import NavFooter from './PnfFooter';
import NavHeader from './NavHeader';
import NoticeFormSignIn from './ReportPageSignin';
import PnfLandingPage from './PnfLandingPage';
import { PageBanner } from './PageBanner';

export function App() {
  const { context } = useTrimContext();
  return (
    <>
      {context && (
        <NavHeader
          authenticationState={context.authenticationState}
          currentLocale={context.currentLocale}
          supportedLanguages={context.supportedLanguages}
        />
      )}
      <PageBanner />
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/report/infringement"
            render={(props) => (
              <div className="page-container">
                <PnfLandingPage
                  authenticationState={context?.authenticationState}
                  domainCountryCode={context?.domainCountryCode || CountryCode.US}
                  routerProps={props}
                  userFirstName={context?.firstName || ''}
                />
              </div>
            )}
          />
          <Route
            exact
            path="/report/infringement/signin"
            render={() => (
              <div className="page-container">
                <NoticeFormSignIn
                  authenticationState={context?.authenticationState}
                  domainCountryCode={context?.domainCountryCode || CountryCode.US}
                />
              </div>
            )}
          />
        </Switch>
      </BrowserRouter>
      {context && <NavFooter footerLinks={context.footerLinks} />}
    </>
  );
}
